module.exports = __webpack_public_path__ + "static/img/01-友链1.a724d3c.png";


//////////////////
// WEBPACK FOOTER
// ./public/pc/01-友链1.png
// module id = baf0
// module chunks = 14